import { CDSUserRoleAndToken, UserInfo } from '@/common/types';
import {
  EMAIL_CONTENT_REGISTRATION_ROLE_DEPOSITOR,
  EMAIL_GENERIC_CONTENT_REGISTRATION_MR,
} from '@/constants/contact';

export const getUserRoleCredential = (
  credentials: CDSUserRoleAndToken
): string => {
  return `${credentials.usr}/${credentials.role}`;
};

export const getGenericEmailForRoleDepositor = (): string =>
  EMAIL_CONTENT_REGISTRATION_ROLE_DEPOSITOR;

export const getDepositorInfo = (
  credentials: CDSUserRoleAndToken
): UserInfo => {
  return {
    depositorName: getUserRoleCredential(credentials),
    depositorEmail: credentials.usr.includes('@')
      ? credentials.usr
      : getGenericEmailForRoleDepositor(),
  };
};

export const getMrDepositorInfo = (
  credentials: CDSUserRoleAndToken
): UserInfo => {
  return {
    depositorName: getUserRoleCredential(credentials),
    depositorEmail: credentials.usr.includes('@')
      ? credentials.usr
      : EMAIL_GENERIC_CONTENT_REGISTRATION_MR,
  };
};
